import { posts, getPosts, homeFeatures, getHomeFeatures } from '../apis';
import easter from '../images/easter.jpg'

global css html
	ff: "Source Sans Pro"
	h1
		fw: 700
		fs: 5rem

	.btn
		d:flex
		px:1em
		py:.5em
		jc:center
		ai:center
		c:white
		fw:bold
		td:none
		flg:1
		transition:background-color .5s
		bgc:transparent @hover:cooler9

		&.btn-primary bgc:blue4 @hover:blue6
		&.btn-success bgc:green6 @hover:green8
		&.btn-danger bgc:red6 @hover:red8
		&.btn-warning bgc:amber5 @hover:amber6
		&.btn-footer d:flex ai:flex-end pb:3em py@lt-sm:.5em py@lt-sm:1em
		&.btn-menu
			fs:1.5em
			c:warmer7
			bgc@hover:unset
			bdb: 5px solid white
			bdb@hover: 5px solid warmer7
			fs@lt-sm:1em

tag home-page

	def mount
		getHomeFeatures()
		getPosts({ limit: 3 })

	<self.app id="home">
		<shape-header
			image=easter
			title="Grace Lutheran Church">

		# Pinned, CMS-managed sections (Welcome, Visit Us, Weddings, Online Giving, …)
		for feature, index in homeFeatures
			<home-feature data=feature flipped=(index % 2 === 1)>

		for post, index in posts
			<post-tag data=post flipped=(index % 2 === 0)>

		<footer-section>